import { render, staticRenderFns } from "./integrations-sms-api.vue?vue&type=template&id=44f8ac83"
import script from "./integrations-sms-api.vue?vue&type=script&lang=js"
export * from "./integrations-sms-api.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports